import { useEffect } from 'react';
import { LandingPageBody } from '~/jobiqo/components/Landingpage';
import { getMiniSiteJobsPath } from '~/jobiqo/components/Organization/MiniSite/utils';
import { analyticsDispatchDelayed, EVENTS } from '~/jobiqo/lib/analytics';
import { OrganizationMiniSiteLayout } from './OrganizationMiniSiteLayout';
import { OrganizationMiniSiteTabs } from './OrganizationMiniSiteTabs';
import type { OrganizationMiniSiteLandingPageProps } from './types';
import {
  getMiniSiteLandingPageDimensions,
  getMiniSiteMenuItems,
  getMiniSiteMenuTabValue,
  getMiniSiteRootPath,
} from './utils';

export const OrganizationMiniSiteLandingPage = ({
  organization,
  landingPage,
  path,
}: OrganizationMiniSiteLandingPageProps) => {
  // Subpages need an easy way back to the mini-site root for Home/Jobs tabs.
  const miniSiteRootPath = getMiniSiteRootPath(organization);
  const menuItems = getMiniSiteMenuItems(organization);
  const currentMenuItem = menuItems.find((menuItem) => menuItem.path === path);

  useEffect(() => {
    analyticsDispatchDelayed(
      EVENTS.MINISITE_LANDING_PAGE_VISIT,
      getMiniSiteLandingPageDimensions(organization, landingPage, path),
    );
  }, [
    landingPage.id,
    landingPage.title,
    organization.id,
    organization.name,
    organization.organization?.id,
    organization.organization?.name,
    organization.ownerId,
    path,
  ]);

  return (
    <OrganizationMiniSiteLayout
      organization={organization}
      headerContent={
        <OrganizationMiniSiteTabs
          activeTab={
            currentMenuItem
              ? getMiniSiteMenuTabValue(currentMenuItem.path)
              : undefined
          }
          homePath={miniSiteRootPath}
          jobsPath={getMiniSiteJobsPath(miniSiteRootPath)}
          menuItems={menuItems}
        />
      }
    >
      <LandingPageBody
        entity={landingPage}
        // LandingPageBody uses this value to namespace sections/slots. Convert
        // URL paths into stable, path-like identifiers without slashes.
        path={path === '/' ? 'home' : path.replace(/\//g, '-')}
      />
    </OrganizationMiniSiteLayout>
  );
};
